import { Gem } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { interpolate } from '../../utils/cabinI18n';

export default function MilesBadge({ miles = 0, className = '' }) {
  const { t, lang } = useLanguage();
  const formatted = new Intl.NumberFormat(lang === 'tr' ? 'tr-TR' : 'en-US').format(miles);
  const ariaLabel = interpolate(t('cabin.a11y.total_miles'), { count: formatted });

  return (
    <div
      className={`flex items-center gap-1 ${className}`}
      role="img"
      aria-label={ariaLabel}
      data-testid="cabin-miles-badge"
    >
      <Gem size={18} className="text-cyan-300" aria-hidden="true" strokeWidth={2.5} />
      <span className="text-sm font-bold text-white tabular-nums">{formatted}</span>
    </div>
  );
}
